<script setup>
const founders = [
  {
    photo: 'frontend/img/virgilio-rodriguez.webp',
    name: 'Virgilio Rodríguez Guerra García',
    biography:
      'Responsable de la gestión de Repuestos, Logística de vehículos, Clientes, Postventa y Sistemas, en representantes de marca de primer nivel, así como en la gestión de siniestros vehiculares en el sector de seguros. Graduado en Ingeniería Mecánica en la Pontificia Universidad Católica del Perú. Diplomado en Sistemas de Información por ESAN y Máster en Administración de Negocios por el INCAE Business School y la Universidad Adolfo Ibáñez.',
  },
  {
    photo: 'frontend/img/juan-villaorduna.webp',
    name: 'Juan Villaorduña López',
    biography:
      'Se desempeñó como Gerente de postventa de la marca KIA y como Gerente de Soporte Técnico de la marca Hyundai. Anteriormente a cargo de la línea de ensamblaje en la planta de camiones Mitsubishi en el Perú. Graduado en Ingeniería Mecánica por la Universidad Nacional del Callao.',
  },
]
</script>

<template>
  <section class="team">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 class="head__title">Fundadores</h1>
          <div class="team__content">
            <div
              class="team__member"
              v-for="(item, index) in founders"
              :key="index"
            >
              <div class="team__photo">
                <img :src="item.photo" :alt="item.name" v-if="item.photo" />
              </div>
              <div class="team__name">{{ item.name }}</div>
              <div class="team__biography">{{ item.biography }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.team {
  background-color: #f5f5f5;
  padding: 4rem 0 2rem;

  .head__title {
    color: #17894a;
    margin-bottom: 2rem;
    text-align: center;
  }

  &__content {
    align-items: stretch;
    display: flex;
    gap: 2rem;
  }

  &__member {
    background-color: #fff;
    border-radius: 1rem;
    display: flex;
    flex: 0 0 50%;
    flex-direction: column;
    gap: 1rem;
    padding: 2rem;
  }

  &__photo {
    background-color: #d8d8d8;
    border-radius: 0.875rem;
    height: 600px;
    overflow: hidden;

    img {
      display: block;
      height: 100%;
      object-fit: cover;
      object-position: center;
      width: 100%;
    }
  }

  &__name {
    color: #17894a;
    font-size: 1.5rem;
    font-weight: bold;
  }

  &___biography {
    font-size: 0.875rem;
    line-height: 1.5;
  }
}
</style>
